import React from 'react';

// Basic styling
const styles = {
  container: {
    marginTop: '1rem',
    padding: '1rem',
    border: '1px solid #eee',
    borderRadius: '8px',
    backgroundColor: '#f0f8ff', // Light blue background
  },
  title: {
    fontSize: '1.1rem',
    color: '#333',
    marginBottom: '0.8rem',
  },
  link: {
    color: '#1976d2',
    textDecoration: 'none',
    fontWeight: 'bold',
    cursor: 'pointer', // Make it look clickable
  },
  noSop: {
    fontStyle: 'italic',
    color: '#777',
  },
  iframeContainer: { // Style for iframe if used
    marginTop: '10px',
    width: '100%',
    height: '400px', // Adjust height as needed
    border: '1px solid #ccc',
  }
};

const QRScanSOP = ({ sopBase64, sopFileName }) => {

  const handleDownload = () => {
    if (!sopBase64) return;
    const link = document.createElement('a');
    link.href = sopBase64;
    link.download = sopFileName || 'SOP_File'; // Use filename or default
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Check if the Base64 string represents a PDF
  const isPdf = sopBase64 && sopBase64.startsWith('data:application/pdf;base64,');

  return (
    <div style={styles.container}>
      <h4 style={styles.title}>SOP Penggunaan Alat</h4>
      {sopBase64 ? (
        <div>
          {isPdf ? (
            <>
              <p>SOP (PDF):</p>
              {/* Attempt to embed PDF */}
              <div style={styles.iframeContainer}>
                 <iframe
                    src={sopBase64}
                    width="100%"
                    height="100%"
                    title={sopFileName || 'SOP Viewer'}
                 >
                    Browser Anda tidak mendukung iframe PDF. Silakan unduh file.
                 </iframe>
              </div>
              {/* Provide download link as fallback or primary option */}
              <p style={{ marginTop: '10px' }}>
                Tidak dapat melihat?{' '}
                <span onClick={handleDownload} style={styles.link}>
                  Unduh SOP ({sopFileName || 'File SOP'})
                </span>
              </p>
            </>
          ) : (
            // If not PDF, just provide download link
            <p>
              <span onClick={handleDownload} style={styles.link}>
                Unduh SOP ({sopFileName || 'File SOP'})
              </span>
            </p>
          )}
        </div>
      ) : (
        <p style={styles.noSop}>SOP tidak tersedia untuk alat ini.</p>
      )}
    </div>
  );
};

export default QRScanSOP;
